import React, { Component } from 'react';
import { withRouter } from './withRouter';
import hamburgerMenuIcon from '../images/icons/hamburger-icon-white.svg'

class NavBar extends Component {

  constructor(props) {
    super(props);

    this.state = { isOpened : false };

    this.navbarRef = React.createRef();
  }

  scrollToElement(id) {

    this.closeNavMenu();

    if(window.location.pathname !== "/") 
    {
        this.props.navigate("/#" + id);
    }
    else
    {
        let element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }
  }

  openNavMenu() {
    this.setState({ isOpened : true })
  }

  closeNavMenu() {
    this.setState({ isOpened : false })
  }

  toggleNavMenu() {
    if (this.state.isOpened) this.closeNavMenu();
    else this.openNavMenu();
  }

  render() {
    const navbarStateClass = this.state.isOpened ? "navbar-developped" : "";

    return (
    <div className={`navbar ${navbarStateClass}`} ref={this.navbarRef}>
        <h3 className='navbar-link' onClick={() => this.scrollToElement("home")}>FLORIAN MATHIEU</h3>

        <div className='navbar-links'>
            <div className='navbar-link' onClick={() => this.scrollToElement("home")}>HOME</div>
            <div className='navbar-link' onClick={() => this.scrollToElement("about-me")}>ABOUT ME</div>
            <div className='navbar-link' onClick={() => this.scrollToElement("projects")}>PROJECTS</div>
            <div className='navbar-link' onClick={() => this.scrollToElement("experiences")}>EXPERIENCES</div>
            <div className='navbar-link' onClick={() => this.scrollToElement("studies")}>STUDIES</div>
        </div>

        <div className='navbar-hamburger'>
          <img src={hamburgerMenuIcon} onClick={() => this.toggleNavMenu()} alt=''></img>
        </div>

        <div className='navbar-nav'>
            <div onClick={() => this.scrollToElement("home")}>HOME</div>
            <div onClick={() => this.scrollToElement("about-me")}>ABOUT ME</div>
            <div onClick={() => this.scrollToElement("projects")}>PROJECTS</div>
            <div onClick={() => this.scrollToElement("experiences")}>EXPERIENCES</div>
            <div onClick={() => this.scrollToElement("studies")}>STUDIES</div>
        </div>

    </div>
    );
  }
}

export default withRouter(NavBar)
